export default function ChatgptHome() {
  return <h2>Chatgpt Home</h2>;
}
